// @flow

import * as React from "react";
import { useState } from "react";
import { ahpraNumber, strictPasswordValidator } from "@constants/Validators";

import ReCAPTCHA from "react-google-recaptcha";
import Config from "../../constants/Config";
import { Row, Col } from "@components/organisms/Grid";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";
import FormPasswordWithValidation from "../atoms/FormPasswordWithValidation";

type PropsType = {
    action: ?string,
    hiddenInputs: ?any,
};

const RegisterForm = (props: PropsType): React.Node => {
    const [capKey, setCapKey] = useState(null);
    return (
        <ReactForm
            validators={[ahpraNumber, strictPasswordValidator]}
            pageSubmit
            method="POST"
            action={props.action || ""}
        >
            <Row>
                <Col xs={12} sm={6}>
                    <ReactFormField
                        type="text"
                        name="first_name"
                        required={true}
                        errorMessages={{
                            required: "Please enter a first name.",
                        }}
                        label="First name"
                    />
                </Col>

                <Col xs={12} sm={6}>
                    <ReactFormField
                        type="text"
                        name="last_name"
                        required={true}
                        errorMessages={{
                            required: "Please enter a last name.",
                        }}
                        label="Last name"
                    />
                </Col>
            </Row>
            <ReactFormField
                type="email"
                name="email"
                required={true}
                validators={["email"]}
                errorMessages={{
                    required: "Please enter an email.",
                }}
                label="Email"
            />
            <ReactFormField
                type="text"
                name="ahpra_number"
                required={true}
                validators={["ahpraNumber"]}
                errorMessages={{
                    required: "Please enter an AHPRA number.",
                }}
                label="AHPRA number"
                info={`<a href="https://www.ahpra.gov.au/Registration/Registers-of-Practitioners.aspx" target="_blank">Can't find your AHPRA number?</a>`}
            />
            <ReactFormField
                type="password"
                name="password"
                required={true}
                validators={["vaxiplace-password-strict"]}
                errorMessages={{
                    required: "Please enter a password.",
                }}
                label="Password"
                placeholder=""
                fieldComponent={FormPasswordWithValidation}
            />
            <ReactFormField
                type="checkbox"
                label="I verify that I am an Australian Healthcare Professional"
                name="verify-professional"
                required={true}
                errorMessages={{
                    required:
                        "Please confirm that you are an Australian Healthcare Professional.",
                }}
            />
            <ReactFormField
                type="checkbox"
                label='I consent to receive educational and promotional updates and electronic communications on upcoming meetings, innovations, and products from Sanofi-Aventis Australia and its affiliates. &lt;a href="https://www.sanofi.com.au/en/privacy-policy" target="_blank"&gt;Privacy policy&lt;/a&gt;.'
                name="consent-promotional"
            />
            <ReactFormField
                type="checkbox"
                label="I agree to Sanofi being able to collect, use, store and disclose information on the basis outlined below."
                name="consent-information"
                required={true}
                errorMessages={{
                    required: "This field is required.",
                }}
            />
            <div className="scrollable-div">
                Your personal information is being collected by Sanofi-Aventis
                Australia Pty Ltd (ABN 31 008 558 807) and its affiliates
                (together Sanofi, we or us. Under the Privacy Act 1988 (Privacy
                Act), we are required to tell you that we collect personal
                information (as defined in the Privacy Act), such as your name,
                contact details and AHPRA details and AHPRA number to assist in
                providing access to (and the administration of) this and other
                HCP restricted websites that you access and that are maintained
                by Sanofi. Besides our employees, affiliates and contractors, we
                may also share this information with external service providers
                so that they may perform services for us or on our behalf. As
                Sanofi is a global pharmaceutical company, some personal
                information may be transferred overseas (including but not
                limited to South Korea and Japan). If we cannot collect that
                information we may not be able to provide these services. You
                have the right to ask for a copy of any personal information we
                hold about you, and to ask for it to be corrected if you think
                it is wrong. To find out more about our privacy policy, how we
                use your personal information, You have the right to ask for a
                copy of any personal information we hold about you, and to ask
                for the Australian Privacy Principles, please visit{" "}
                <a
                    href="https://www.sanofi.com.co/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    www.sanofi.com.co/privacy-policy
                </a>
                .
            </div>
            <div className="recaptcha_validator-container">
                <ReactFormField
                    type="text"
                    name="recaptcha_validator"
                    value={capKey}
                    required={true}
                    readOnly={true}
                    errorMessage={{
                        required: "Please accept recaptcha.",
                    }}
                    label="Recaptcha"
                />
            </div>
            <ReCAPTCHA
                onChange={captchaKey => {
                    setCapKey(captchaKey);
                }}
                onExpired={() => {
                    setCapKey("");
                }}
                onErrored={() => {
                    setCapKey("");
                }}
                sitekey={Config.recaptchaSiteKey}
            />

            {capKey === "" && (
                <p className="recaptcha-error">recaptcha is needed</p>
            )}

            <button
                type="submit"
                className="button button--wide"
                onClick={() => {
                    if (capKey === null) {
                        setCapKey("");
                    }
                }}
            >
                Register
            </button>
            {props.hiddenInputs || null}
        </ReactForm>
    );
};

export default RegisterForm;
